import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(props, _ref) {
    var $f7, $f7router, $, $on, $update, user, notifications, notifications_hidden, notifications_read, bgcolors, n, setColor, cardOpened, deleteNotification, cardClose;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            $f7 = _ref.$f7, $f7router = _ref.$f7router, $ = _ref.$, $on = _ref.$on, $update = _ref.$update;

            /*
             * Inizializza variabili
             */
            user = {
              data: {}
            };
            notifications = [];
            notifications_hidden = [];
            _context4.next = 6;
            return myStorage.get('notifications_read', true);

          case 6:
            _context4.t0 = _context4.sent;

            if (_context4.t0) {
              _context4.next = 9;
              break;
            }

            _context4.t0 = [];

          case 9:
            notifications_read = _context4.t0;
            bgcolors = 'primary,secondary,red,blue,pink,yellow,orange,purple,deeppurple,teal,deeporange,gray,black'.split(',');
            n = 0;

            setColor = function setColor(index) {
              if (index <= bgcolors.length) return bgcolors[index];else {
                if (n > bgcolors.length) n = 0;
                return bgcolors[n++];
              }
            };
            /*
             * Page event
             * Per impostazione predefinita visualizza gli item attivi
             * https://framework7.io/docs/router-component.html#component-page-events
             */


            $on('pageBeforeIn', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return myApp.user();

                    case 2:
                      user = _context.sent;
                      _context.next = 5;
                      return myStorage.get('notifications_hidden', true);

                    case 5:
                      _context.t0 = _context.sent;

                      if (_context.t0) {
                        _context.next = 8;
                        break;
                      }

                      _context.t0 = [];

                    case 8:
                      notifications_hidden = _context.t0;
                      console.log(notifications_hidden);
                      notifications = (user.data.notifications || []).filter(function (item) {
                        return notifications_hidden.indexOf(item.id + '') === -1;
                      });
                      n = 0;
                      $update();

                    case 13:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            })));

            cardOpened = /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ev) {
                var id;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        id = $(ev.target).data('id');
                        if (notifications_read.indexOf(id) === -1) notifications_read.push(id);
                        _context2.next = 4;
                        return myStorage.set('notifications_read', notifications_read);

                      case 4:
                        myApp.badgeNotificationsUpdated = true;

                      case 5:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function cardOpened(_x3) {
                return _ref4.apply(this, arguments);
              };
            }();

            deleteNotification = /*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(ev) {
                var id;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        id = $(ev.target).data('id');
                        if (notifications_hidden.indexOf(id) === -1) notifications_hidden.push(id);
                        _context3.next = 4;
                        return myStorage.set('notifications_hidden', notifications_hidden);

                      case 4:
                        $f7.card.close('#card_' + id);
                        notifications = notifications.filter(function (item) {
                          return notifications_hidden.indexOf(item.id + '') === -1;
                        });
                        $update();

                      case 7:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function deleteNotification(_x4) {
                return _ref5.apply(this, arguments);
              };
            }();

            cardClose = function cardClose(ev) {
              $(ev.target).find('.notification-to-read').addClass('hidden');
            };

            return _context4.abrupt("return", function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="pageName">
    <!-- Top Navbar -->
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left">
          <a href="#" class="link back">
            <i class="f7-icons ios-only">arrow_left</i>
            <i class="material-icons md-only">arrow_back</i>
          </a>
        </div>
        <div class="title sliding">Doctor Pass</div>
        <div class="right">
          <a href="#" class="link icon-only panel-open" data-panel="right">
            <i class="icon f7-icons if-not-md">menu</i>
            <i class="icon material-icons if-md">menu</i>
          </a>
        </div>
      </div>
    </div>
    <!-- Scrollable page content-->
    <div class="page-content bg-color-white">

      ${notifications.map((item, index) => $h`
      <div class="card card-expandable" @card:opened=${cardOpened} @card:close=${cardClose} id="card_${item.id}" data-id="${item.id}">
        <div class="card-content">
          <div class="bg-color-${item.bg||setColor(index)}" style="height: 300px">
            <div class="card-header text-color-${item.color || 'white'} display-block">
              
              ${notifications_read.indexOf(item.id + '') === -1 && $h`
              <div class="float-right notification-to-read">NEW</div>
              `}
         
              
              <span class="padding-right" innerHTML="${item.icon}"></span>  ${item.title} <br />
              <small style="opacity: 0.7">${item.subtitle}</small> <br />
              <!-- <small><small style="opacity: 0.7">${item.type}</small></small> -->
              ${item.img && $h`
              <div class="notification-image" style="background-image: url( ${item.img} )"></div>
              `}
            </div>
            <a href="#" class="link card-close card-opened-fade-in color-white"
               style="position: absolute; right: 15px; top: 15px">
              <i class="icon f7-icons">xmark_circle_fill</i>
            </a>
          </div>
          <div class="card-content-padding">
            <div class="margin-bottom" innerHTML=${item.text}></div>
            ${item.img && $h`
            <img src='${item.img}' width='100%' />
            `}
            ${item.link && $h `
            <div class="margin-vertical">
              <a href="${item.link}" class="external button button-large button-fill button-round" target="_system">${lng.learn_more}</a>
            </div>
            `}
            <div class="margin-top">
              <br/><br/><br/>
              <button class="button button-link color-gray" @click=${deleteNotification} data-id="${item.id}">
                <i class="f7-icons margin-right">trash</i>
                ${lng.delete}
              </button>
            </div>
          </div>
        </div>
      </div>
      `)}

      ${notifications.length == 0 && $h`
      <div class="display-flex flex-direction-column justify-content-center align-items-center h-90">
        <img width="150" src="static/notfound.svg"/>
        <h3>${lng.notifications_empty_message}.</h3>
      </div>
      `}

    </div>
  </div>
`
    }
    );

          case 18:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
})();